nodeIsMap